import React from 'react';
import { Link } from 'gatsby';

import Html from 'views/components/html';
import Header from 'views/components/header';
import Body from 'views/components/body';
import Contents from 'views/components/contents';
import Breadcrumb from 'views/components/breadcrumb';
import BackToTopButton from 'views/components/back-to-top-button';
import Footer from 'views/components/footer';
import { Background, Heading, Table, Information, Picture, Message, History } from './index.styled';
import title from './assets/title.gif';
import headquarters from './assets/headquarters.jpg';

const Company = () => {
  return (
    <>
      <Html title="会社概要" />
      <Header />
      <Body>
        <Contents>
          <Breadcrumb><Link to="/">HOME</Link>　&gt;　会社概要</Breadcrumb>
          <Background>
            <Heading>
              <h1><img src={title} alt="会社概要" /></h1>
            </Heading>
            <Information>
              <h2>会社情報</h2>
              <Table>
                <table>
                  <tbody>
                  <tr>
                    <th>名称</th>
                    <td>株式会社野中製作所</td>
                  </tr>
                  <tr>
                    <th>所在地</th>
                    <td>
                      〒577-0016　大阪府東大阪市長田西5丁目1番15号<br />
                      TEL　06-6747-1118（代）<br />
                      FAX　06-6747-1188
                    </td>
                  </tr>
                  <tr>
                    <th>代表取締役</th>
                    <td>野中 恒夫</td>
                  </tr>
                  <tr>
                    <th>創立年月日</th>
                    <td>昭和59年4月3日</td>
                  </tr>
                  <tr>
                    <th>資本金</th>
                    <td>1000万円</td>
                  </tr>
                  <tr>
                    <th>従業員数</th>
                    <td>40名（男性19名・女性21名）</td>
                  </tr>
                  <tr>
                    <th>営業品目</th>
                    <td>精密プラスチック射出成形</td>
                  </tr>
                  <tr>
                    <th>主要製品</th>
                    <td>
                      導光板<br />
                      LED<br />
                      部品AV機器<br />
                      携帯電話部品<br />
                      自動車部品<br />
                      樹脂ギアー<br />
                      ゲーム機<br />
                      透明アクリル板<br />
                      精密エンプラ部品<br />
                      各種プラスチック部品
                    </td>
                  </tr>
                  </tbody>
                </table>
              </Table>
            </Information>
            <Picture>
              <h2>本社</h2>
              <img src={headquarters} alt="本社" />
            </Picture>
            <Message>
              <h2>ごあいさつ</h2>
              <div>
                <p>
                  現在、産業のグローバル化が進む中、<br />
                  プラスチック成形加工も大陸へ生産拠点が移っております。<br />
                  その中にあって、<br />
                </p>
                <ul>
                  <li>・全ての製品に最高の技術をもって対応します。</li>
                  <li>・常にお客様を喜ばせることが、次の依頼につながります。</li>
                </ul>
                <p>
                  をモットーに、<br />
                  スタッフの技術の向上、工場の5Sの推進、お客さまに対する<br />
                  迅速な対応など日々努力しております。
                </p>
                <p>
                  代表取締役社長<br />
                  野中 恒夫
                </p>
              </div>
            </Message>
            <History>
              <h2>沿革</h2>
              <Table>
                <table>
                  <tbody>
                  <tr>
                    <th>昭和52年</th>
                    <td>大阪市鶴見区今津中3丁目にて野中製作所を創業</td>
                  </tr>
                  <tr>
                    <th>昭和58年</th>
                    <td>大阪市鶴見区今津北3丁目に工場移転</td>
                  </tr>
                  <tr>
                    <th>昭和59年4月</th>
                    <td>
                      資本金300万の法人設立<br />
                      社名 株式会社 野中製作所
                    </td>
                  </tr>
                  <tr>
                    <th>平成7年6月</th>
                    <td>資本金1000万に増資</td>
                  </tr>
                  <tr>
                    <th>平成15年2月</th>
                    <td>
                      東大阪市長田西5丁目1番15号に本社移転</td>
                  </tr>
                  <tr>
                    <th>平成18年2月</th>
                    <td>本社東隣りに新工場増設<br />今津工場を移転 クリーンブースを設置</td>
                  </tr>
                  <tr>
                    <th>平成19年5月</th>
                    <td>新倉庫増設</td>
                  </tr>
                  </tbody>
                </table>
              </Table>
            </History>
          </Background>
          <BackToTopButton />
        </Contents>
      </Body>
      <Footer />
    </>
  );
};

export default Company;
